import { fetchWithHandling } from "utils/common-utils";
import { Filters, GetModelPaginatedRs, Model } from "utils/interfaces";

const API_URL = `${process.env.REACT_APP_BACKEND_API_PREFIX}/api/v1/models`

export const getAllPaginated = async (
    jwtToken: string,
    onSessionExpired: () => void,
    filters: Filters<any> = {}
): Promise<GetModelPaginatedRs | undefined> => {
    try {
        // Crea la stringa dei query parameters a partire dai filtri
        const queryParams = new URLSearchParams();

        if (filters.pageNumber) {
            queryParams.append('pageNumber', filters.pageNumber);
        }

        if (filters.modelName) {
            queryParams.append('name', filters.modelName);
        }

        if (filters.modelTypeId) {
            queryParams.append('modelTypeId', filters.modelTypeId);
        }

        // Aggiungi i parametri alla URL
        const url = queryParams.size > 0 ? `${API_URL}/paginated?${queryParams.toString()}` : `${API_URL}/paginated`;

        const jsonData = await fetchWithHandling(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => {
                onSessionExpired();
            }
        );

        return jsonData as GetModelPaginatedRs;
    } catch (error) {
        return undefined;
    }
};

export const createModel = async (
    jwtToken: string,
    onSessionExpired: () => void,
    name: string,
    modelTypeId: number,
    content: string,
    jsonTemplate: string,
    coverImg: File
): Promise<Model | undefined> => {
    try {
        const formData = new FormData();
        formData.append('name', name);
        formData.append('modelTypeId', modelTypeId.toString());
        formData.append('content', content);
        formData.append('jsonTemplate', jsonTemplate);
        formData.append('coverImg', coverImg);

        const jsonData = await fetchWithHandling(
            API_URL,
            {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: formData,
            },
            () => {
                onSessionExpired();
            }
        );

        return jsonData as Model;
    } catch (error) {
        return undefined;
    }
};

export const updateModel = async (
    jwtToken: string,
    onSessionExpired: () => void,
    id: number,
    name: string,
    modelTypeId: number,
    content: string,
    jsonTemplate: string,
    coverImg: File
): Promise<Model | undefined> => {
    try {
        const formData = new FormData();
        formData.append('id', String(id));
        formData.append('name', name);
        formData.append('modelTypeId', modelTypeId.toString());
        formData.append('content', content);
        formData.append('jsonTemplate', jsonTemplate);
        formData.append('coverImg', coverImg);

        const jsonData = await fetchWithHandling(
            API_URL,
            {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: formData,
            },
            () => {
                onSessionExpired();
            }
        );

        return jsonData as Model;
    } catch (error) {
        return undefined;
    }
};


export const deleteModel = async (
    jwtToken: string,
    onSessionExpired: () => void,
    id: number
): Promise<boolean> => {
    try {
        await fetchWithHandling(
            `${API_URL}/${id}`,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => {
                onSessionExpired();  // Chiamata al callback per la gestione della scadenza della sessione
            }
        );
        return true;
    } catch (error) {
        return false;
    }
};

export const getModelById = async (
    jwtToken: string,
    onSessionExpired: () => void,
    id: number
): Promise<Model> => {
    try {
        const jsonData = await fetchWithHandling(
            `${API_URL}/${id}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => {
                onSessionExpired();  // Chiamata al callback per la gestione della scadenza della sessione
            }
        );
        return jsonData as Model;

    } catch (error) {
        return undefined;
    }
};